export default {
  setProduct(state, product) {
    state.product = product;
  },
  setSimilar(state, similar) {
    state.similar = similar;
  },
  setReviews(state, reviews) {
    state.reviews = reviews;
  }
};
